import { Typography } from "@mui/material";

export function Copyright(props) {
    return (
        <Typography
            variant="body2"
            color="text-white"
            align="left"
            {...props}
        >
            {`Copyright ©${new Date().getFullYear()}. All Rights Reserved `}
            <a color="inherit" href="https://codemontis.com/" target="_blank" rel="noreferrer">
                Codemontis
            </a>
        </Typography>
    );
}

export const isValidEmail = (email) => {
    const pattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/;
    const patter1 = /^[\w.%+-]+@[\w.-]+\.[A-Za-z]{2,}$/;
    return pattern.test(email) || patter1.test(email);
};
